import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import AdminDashboard from "./AdminDashboard";
import SignupPage from "./subscription/SignupPage";
import ManagePage from "./subscription/ManagePage";
import AccessPage from "./subscription/AccessPage";
import AccountPage from "./subscription/AccountPage";
import CheesecakePage from "./CheesecakePage";

const path = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById("root"));

function routeElement() {
  if (path.startsWith("/admin")) return <AdminDashboard />;
  if (path.startsWith("/subscription/signup")) return <SignupPage />;
  if (path.startsWith("/subscription/manage")) return <ManagePage />;
  if (path.startsWith("/subscription/access")) return <AccessPage />;
  if (path.startsWith("/subscription/account")) return <AccountPage />;
  if (path.startsWith("/cheesecake")) return <CheesecakePage />;
  return <App />;
}

root.render(routeElement());
